(() => {
  angular
    .module('app.settings')
    .factory('IntegratedCampaignsService', IntegratedCampaignsService);

  IntegratedCampaignsService.$inject = ['$resource'];

  function IntegratedCampaignsService($resource) {
    return $resource('/integratedcampaigns/:action', {}, {
      get: {
        method: 'GET',
        params: {
          action: 'get',
        }
      },
      create: {
        method: 'POST',
        params: {
          action: 'create',
        }
      },
      delete: {
        method: 'POST',
        params: {
          action: 'delete',
        }
      },
      update: {
        method: 'POST',
        params: {
          action: 'update',
        }
      }
    });
  }
})();
